export const FIXED_PASSWORD = "noccarc";
export const AUTH_STORAGE_KEY = "preuse-authenticated";
export const AUTH_STORAGE_VALUE = `ok:${FIXED_PASSWORD}`;
